export default {
  space: {
    dashboard_card_padding: 5,
  },
}
